export const CUSTOMER_PACKAGING_DEFAULT_ORDER_TYPE_KEY = '_default'

export const DISPATCH_PACKAGING_TYPE_OPTIONS = [
  { value: 'transparent_bag', label: '透明袋' },
  { value: 'woven_bag', label: '蛇皮袋' }
]

export function packagingTypeLabel(value) {
  const hit = DISPATCH_PACKAGING_TYPE_OPTIONS.find((o) => o.value === value)
  return hit?.label || '未指定'
}

/** 按客户 + 订单类型解析包装预设；优先精确匹配，其次客户通用规则 */
export function resolveCustomerPackagingRequirement(nestedMap, customerId, orderTypeId) {
  if (!nestedMap || customerId == null || customerId === '') return null
  const byCustomer = nestedMap[String(customerId)]
  if (!byCustomer) return null
  const otKey = orderTypeId != null && orderTypeId !== '' ? String(orderTypeId) : null
  if (otKey && byCustomer[otKey]) return { ...byCustomer[otKey] }
  if (byCustomer[CUSTOMER_PACKAGING_DEFAULT_ORDER_TYPE_KEY]) {
    return { ...byCustomer[CUSTOMER_PACKAGING_DEFAULT_ORDER_TYPE_KEY] }
  }
  return null
}

export function applyCustomerPackagingRequirementToRow(row, nestedMap) {
  if (!row) return row
  const rule = resolveCustomerPackagingRequirement(
    nestedMap,
    row.customer_id,
    row.order_type_id
  )
  if (!rule) return row
  return {
    ...row,
    packaging_type: rule.packaging_type ?? '',
    packaging_require_weigh: !!rule.packaging_require_weigh,
    packaging_require_volume: !!rule.packaging_require_volume
  }
}
